import { useStore } from '@nanostores/react';
import { lazy, memo } from 'react';
import { LazyLoadWrapper, retry } from '~/components/ui/LazyLoadWrapper';
import { descriptionStore } from '~/lib/stores/description';

const ProjectSettings = lazy(
  retry(() =>
    import('./ProjectSettings.client').then((module) => ({
      default: module.ProjectSettings,
    })),
  ),
);

export const ProjectInfo = memo(() => {
  const description = useStore(descriptionStore);

  return (
    <LazyLoadWrapper name="ProjectSettings" fallback={<span className="max-w-96 text-xs truncate">{description}</span>}>
      <ProjectSettings />
    </LazyLoadWrapper>
  );
});
